/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../service/floorplan/correction.model.ts" />

module Eseebase {
    export class FloorPlanService {
        //private baseUrl = 'http://eseebase.azurewebsites.net';
        constructor(private $http: ng.IHttpService, private baseService: BaseService) { }

        public getFloorPlanDrawings(filter: ModelFilterViewModel, allCorrections: boolean, newCorrections: boolean, changedCorrections: boolean, isMyReports: boolean, lastId: string) {
            return this.baseService.post('floorplan/{companyNumber}/filter?lastId=' + lastId + '&allCorrections=' + allCorrections + '&newCorrections=' + newCorrections + '&changedCorrections=' + changedCorrections + (!isMyReports ? '&show3d=true&showPdf=true' : '&show3d=false&showPdf=false'), filter).then(j => { return j.data });
        }

        public getFloorPlans(filter: ModelFilterViewModel, allCorrections: boolean, newCorrections: boolean, changedCorrections: boolean, isMyReports: boolean, lastId: string) {
            return this.baseService.post('floorplan/{companyNumber}/search?lastId=' + lastId + '&allCorrections=' + allCorrections + '&newCorrections=' + newCorrections + '&changedCorrections=' + changedCorrections + (!isMyReports ? '&show3d=true&showPdf=true' : '&show3d=false&showPdf=false'), filter).then(j => { return j.data });
        }

        public getFloorPlanCount(filter: ModelFilterViewModel, allCorrections: boolean, newCorrections: boolean, changedCorrections: boolean, isMyReports: boolean) {
            return this.baseService.post('floorplan/{companyNumber}/filtercount?allCorrections=' + allCorrections + '&newCorrections=' + newCorrections + '&changedCorrections=' + changedCorrections + (!isMyReports ? '&show3d=true&showPdf=true' : '&show3d=false&showPdf=false'), filter).then(j => { return j.data });
        }

        public getMainDrawings(filter: ModelFilterViewModel, pageNumber: number) {
            return this.baseService.post('maindrawing/{companyNumber}/filter?pageNumber=' + pageNumber, filter).then(j => { return j.data });
        }

        public floorplansExist(filter: ModelFilterViewModel) {
            return this.baseService.post('floorplan/{companyNumber}/any', filter).then(j => { return j.data });
        }

        public saveCorrection(correction: CorrectionViewModel) {
            return this.baseService.post('correction/{companyNumber}', correction).then(j => j.data);
        }

        public uploadAttachment(associationNumber: string, departmentNumber: string, sheetNumber: string, data: FormData) {
            return this.baseService.upload('correction/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + sheetNumber + '/upload', data, null);
        }

        public getCorrection(associationNumber: string, departmentNumber: string, apartmentNumber: string) {
            return this.baseService.get('correction/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + apartmentNumber).then(j => { return j.data });
        }

        public deleteCorrection(id: string) {
            return this.baseService.delete('correction/{companyNumber}?id=' + id);
        }

        public addComment(correctionId: string, text: string) {
            return this.baseService.post('correction/{companyNumber}/comment?correctionId=' + correctionId, { 'text': encodeURIComponent(text) }).then(j => { return j.data });
        }

        public completeCorrection(associationNumber: string, departmentNumber: string, localizer: string, sheetNumber: string) {
            return this.baseService.post(`correction/{companyNumber}/${associationNumber}/${departmentNumber}/${localizer}/${sheetNumber}/complete`, {}).then(j => { return j.data });
        }

        public getChangelog() {
            return this.baseService.get('correction/{companyNumber}/changelog').then(j => { return j.data });
        }

        public getChangelogItems(companyNumber: string, associationNumber: string, departmentNumber: string, localizer: string) {
            return this.baseService.get('correction/' + companyNumber + '/changelogitems?associationNumber=' + associationNumber + '&departmentNumber=' + departmentNumber + '&localizer=' + localizer).then(j => { return j.data });
        }

        public getApartmentChangelog(associationNumber: string, departmentNumber: string, localizer: string, sheetNumber: string) {
            return this.baseService.get('correction/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + localizer + '/' + sheetNumber + '/changelog').then(j => { return j.data });
        }

        public getById(id: string) {
            return this.baseService.get('correction/{companyNumber}/' + id).then(j => { return j.data });
        }
    }

    FloorPlanService.$inject = ['$http', 'BaseService'];
    angular
        .module('eseebase')
        .service('FloorPlanService', FloorPlanService);
}